import type { AnalyticsEventPayload } from '@atlaskit/analytics-next';

import { filterCommonAttributes } from './analytics-helpers';
import type { commonAttributesType } from './types';

// Identifies which copy affordance triggered the event so the variants can be told apart.
export type AIAnswerCopySource = 'answer' | 'inline-lumina-link-embed';

// Tracking clicks on the copy button in SAIN answer cards
export const onAIAnswerCopyButtonClicked: (
	props: commonAttributesType,
	copySource?: AIAnswerCopySource,
) => AnalyticsEventPayload = (
	props: commonAttributesType,
	copySource: AIAnswerCopySource = 'answer',
): AnalyticsEventPayload => {
	const { query, answerString, source } = props;
	return {
		action: 'clicked',
		actionSubject: 'aiAnswerCopy',
		source: source,
		eventType: 'track',
		attributes: {
			...filterCommonAttributes(props),
			copySource,
		},
		nonPrivacySafeAttributes: {
			query,
			answerString,
		},
	};
};
